export const isChatbotAiEnabled = (
  search,
  publicUrl = process.env.PUBLIC_URL,
  environment = process.env.NODE_ENV,
) => {
  if (environment === 'production' && publicUrl !== '/pwa') return false;
  const values = new URLSearchParams(search).getAll('chatbotai');
  return values.length === 1 && values[0] === '1';
};

const BROWSER_ACCESS_KEY = 'pwa-navigateur';

// Porte de service pour les tests : « ?navigateur=1 » ouvre la PWA dans un onglet de
// navigateur mobile, et le reste pour la durée de la session de l'onglet.
export const isBrowserAccessAllowed = (search, storage = window.sessionStorage) => {
  const values = new URLSearchParams(search).getAll('navigateur');
  const requested = values.length === 1 && values[0] === '1';
  try {
    if (requested) storage.setItem(BROWSER_ACCESS_KEY, '1');
    return requested || storage.getItem(BROWSER_ACCESS_KEY) === '1';
  } catch {
    return requested;
  }
};
